type Listener = () => void

let transitioning = false
const listeners = new Set<Listener>()

/** True while the page curtain covers the screen during a route change. */
export const isPageTransitioning = (): boolean => transitioning

export const beginPageTransition = (): void => {
    transitioning = true
}

/** Called as the curtain starts lifting; releases everything waiting for the new page to show. */
export const endPageTransition = (): void => {
    if (!transitioning) return
    transitioning = false

    const waiting = Array.from(listeners)
    listeners.clear()
    waiting.forEach((listener) => listener())
}

/** Runs now when no transition is in progress, otherwise as soon as the curtain lifts. */
export const onPageReveal = (listener: Listener): (() => void) => {
    if (!transitioning) {
        listener()
        return () => undefined
    }

    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}
